import React from 'react';

import { Content } from 'LegacySBCRA/Content/Content';

import ContentBody from '../ContentBody';
import type { ACFType } from '../UlezPage.types';

import styles from './InfoUlezPage.module.scss';

const InfoUlezPage = ({ acf }: ACFType) => {
  if (!acf) {
    return null;
  }

  return (
    <Content className={styles.content} element="section">
      <div className={styles.info}>
        <h3>{acf?.section_two_title as string}</h3>
        <ContentBody
          body={acf?.section_two_body_area as string}
        />
      </div>
    </Content>
  );
};

export default InfoUlezPage;
